import React from "react";

export default function ClarifyCard({ clarify, onChip = () => {} }) {
  if (!clarify) return null;
  return (
    <div className="rounded-xl border border-card-bd bg-card p-4">
      <p className="text-sm text-text">{clarify.question}</p>
      {clarify.chips?.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {clarify.chips.map((c) => (
            <button key={c} type="button" onClick={() => onChip(c)} className="text-sm px-3 py-1 rounded-lg border border-border text-text-2 hover:bg-surface-2">
              {c}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
